module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image19.0e83fbaa.webp";